import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 20v-2","key":"svg-0"}],["path",{"d":"M15 8.01v.01","key":"svg-1"}],["path",{"d":"M3 17l8 -8v-1a4 4 0 1 1 8 0h2l-2 2v1a7 7 0 0 1 -13.215 3.223","key":"svg-2"}]]

const IconCanary = createReactComponent('outline', 'canary', 'Canary', __iconNode);

export default IconCanary;